import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@components/PageHeader';
import { Card } from '@components/ui/Card';
import { Button } from '@components/ui/Button';

export const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader
        title="Dashboard"
        subtitle="Welcome to EstateMate - Convert estate plans to BlocPlus JSON"
      />

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <h3 className="mb-4 text-xl font-bold text-gray-800">Start New Conversion</h3>
          <p className="mb-6 text-s text-gray-600">
            Find and convert an Australian estate plan into BlocPlus-ready JSON format.
          </p>
          <Button onClick={() => navigate('/find')}>Find Estate</Button>
        </Card>

        <Card>
          <h3 className="mb-4 text-xl font-bold text-gray-800">Browse BlocPlus</h3>
          <p className="mb-6 text-s text-gray-600">
            Browse live estates from BlocPlus and import lot data directly.
          </p>
          <Button variant="outlined" onClick={() => navigate('/blocplus')}>Browse Estates</Button>
        </Card>

        <Card>
          <h3 className="mb-4 text-xl font-bold text-gray-800">Review Proposed Estates</h3>
          <p className="mb-6 text-s text-gray-600">
            Search VIC proposed parcels, score candidate strength, and export draft JSON.
          </p>
          <Button variant="outlined" onClick={() => navigate('/proposed-estates')}>
            Open Review
          </Button>
        </Card>

        <Card>
          <h3 className="mb-4 text-xl font-bold text-gray-800">Quick Stats</h3>
          <div className="space-y-2 text-s">
            <div className="flex justify-between">
              <span className="text-gray-600">Total Estates:</span>
              <span className="font-bold">0</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Exported:</span>
              <span className="font-bold">0</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
